<div class="dismissal-container" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <label *ngIf="showHeader" (click)="openDismissalReprots()" class="dismissal-header">
        {{'dismissal-flowlog.header' | translate}}
        <svg xmlns="http://www.w3.org/2000/svg" width="6.576" height="11.257" viewBox="0 0 6.576 11.257"
            [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' :'rotate(180deg)'}">
            <g id="next_1_" data-name="next (1)" transform="translate(0.554 0.554)">
                <g id="Group_5442" data-name="Group 5442" transform="translate(0 0)">
                    <path id="Path_5603" data-name="Path 5603"
                        d="M107.651,5.354l-4.687,4.687a.391.391,0,0,1-.552-.552l4.411-4.411L102.411.667a.391.391,0,0,1,.552-.552L107.651,4.8A.391.391,0,0,1,107.651,5.354Z"
                        transform="translate(-102.297 0)" fill="#1d71d3" stroke="#1d71d3" stroke-width="1" />
                </g>
            </g>
        </svg>
    </label>
    <div class="dismissal-process">
        <div class="dismissal-process-header">
            <span>{{'dismissal-flowlog.ready-pickup' | translate}}</span>
            <span>{{'dismissal-flowlog.pickup-recieved' | translate}}</span>
            <span>{{'dismissal-flowlog.dismissal-process' | translate}}</span>
        </div>
        <div class="dismissal-process-body">
            <span>{{dismissalAverageTime.avg_yellow_zone ?
                dismissalAverageTime.avg_yellow_zone : 0 }}
                <span
                    *ngIf="getTimeimMins(dismissalAverageTime.avg_yellow_zone)>1">{{'dismissal-flowlog.mins'|translate}}</span>
                <span *ngIf="getTimeimMins(dismissalAverageTime.avg_yellow_zone)===1 || 
                    getTimeimMins(dismissalAverageTime.avg_yellow_zone)===0
                    ">{{'dismissal-flowlog.min'|translate}}</span>
            </span>
            <span>{{dismissalAverageTime.avg_green_zone ?
                dismissalAverageTime.avg_green_zone:0 }}
                <span
                    *ngIf="getTimeimMins(dismissalAverageTime.avg_green_zone)>1">{{'dismissal-flowlog.mins'|translate}}</span>
                <span *ngIf="getTimeimMins(dismissalAverageTime.avg_green_zone)===1 || 
                getTimeimMins(dismissalAverageTime.avg_green_zone)===0
                ">{{'dismissal-flowlog.min'|translate}}</span>

            </span>
            <span>{{dismissalAverageTime.avg_full_request ?
                dismissalAverageTime.avg_full_request :0}}
                <span
                    *ngIf="getTimeimMins(dismissalAverageTime.avg_full_request)>1">{{'dismissal-flowlog.mins'|translate}}</span>
                <span *ngIf="getTimeimMins(dismissalAverageTime.avg_full_request)===1 || 
                getTimeimMins(dismissalAverageTime.avg_full_request)===0
                ">{{'dismissal-flowlog.min'|translate}}</span>
            </span>
        </div>
    </div>
    <div class="request-section">
        <div class="parent-assistant">
            <div class="parent">
                <span class="blue-req">{{dismissalStatistics.parent_requests ? dismissalStatistics.parent_requests :
                    0}}</span>
                <small>{{'dismissal-flowlog.by-parent' | translate}}</small>
            </div>
            <div class="assistant">
                <span class="gray-req">{{dismissalStatistics.helper_requests ? dismissalStatistics.helper_requests :
                    0}}</span>
                <small>{{'dismissal-flowlog.by-assistant' | translate}}</small>
            </div>
        </div>
        <div class="app-qr">
            <div class="app">
                <span class="blue-req">{{dismissalStatistics.flow_pickup ? dismissalStatistics.flow_pickup : 0}}</span>
                <small>{{'dismissal-flowlog.by-app' | translate}}</small>
            </div>
            <div class="qr">
                <span class="gray-req">{{dismissalStatistics.qr_pickup ? dismissalStatistics.qr_pickup : 0}}</span>
                <small>{{'dismissal-flowlog.by-qrcode' | translate}}</small>
            </div>
        </div>
        <div class="bus-regular">
            <div class="bus">
                <span class="blue-req">{{dismissalStatistics.bus_pickup ? dismissalStatistics.bus_pickup : 0}}</span>
                <small>{{'dismissal-flowlog.by-bus' | translate}}</small>
            </div>
            <div class="regular">
                <span class="gray-req">{{dismissalStatistics.normal_pickup ? dismissalStatistics.normal_pickup
                    :0}}</span>
                <small>{{'dismissal-flowlog.regular' | translate}}</small>
            </div>
        </div>
    </div>
</div>